import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
//Material imports
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress"; //Limitless imports

import { withi18n } from "../../hocs/i18n";

var ActionControlsFooter = /*#__PURE__*/function (_PureComponent) {
  _inherits(ActionControlsFooter, _PureComponent);

  var _super = _createSuper(ActionControlsFooter);

  function ActionControlsFooter() {
    var _this;

    _classCallCheck(this, ActionControlsFooter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      disabled: false
    };
    return _this;
  }

  _createClass(ActionControlsFooter, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          leftButtonTitle = _this$props.leftButtonTitle,
          rightButtonTitle = _this$props.rightButtonTitle,
          leftButtonHandle = _this$props.leftButtonHandle,
          rightButtonHandle = _this$props.rightButtonHandle,
          t = _this$props.t,
          classes = _this$props.classes;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.actionControlsContainer
      }, /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        className: classes.actionControlsButton,
        style: {
          borderBottomLeftRadius: 12
        },
        onClick: function onClick() {
          _this2.setState({
            disabled: true
          });

          leftButtonHandle();
        },
        component: "div",
        disabled: this.state.disabled,
        id: "leftActionControlButton"
      }, t(leftButtonTitle)), rightButtonHandle && /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        className: classes.actionControlsButton,
        style: {
          borderBottomRightRadius: 12
        },
        onClick: function onClick() {
          _this2.setState({
            disabled: true
          });

          rightButtonHandle();
        },
        component: "div",
        disabled: this.state.disabled,
        id: "rightActionControlButton"
      }, t(rightButtonTitle)), this.state.disabled && /*#__PURE__*/React.createElement(CircularProgress, {
        size: 24,
        className: classes.actionControlsLoading
      }));
    }
  }]);

  return ActionControlsFooter;
}(PureComponent);

var styles = function styles(theme) {
  return {
    actionControlsContainer: {
      display: "flex",
      flex: "1",
      justifyContent: "space-around",
      minHeight: 54,
      position: "relative"
    },
    actionControlsButton: {
      flex: 1,
      borderRadius: 0,
      backgroundColor: theme.palette.contrast.light,
      color: theme.palette.contrast.main,
      boxShadow: "none",
      height: 54,
      "&:hover": {
        boxShadow: "inset 0px 0px 0px 99999px rgba(255,255,255,0.2)"
      }
    },
    actionControlsLoading: {
      position: "absolute",
      marginTop: 15,
      left: "48%"
    }
  };
};

export default withStyles(styles, {
  withTheme: true
})(withi18n(ActionControlsFooter));